/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var BookClosedIcon20Regular = forwardRef('BookClosedIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M7 5a.75.75 0 0 0 0 1.5h6A.75.75 0 0 0 13 5H7Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.25 1A3.25 3.25 0 0 0 3 4.25v12.28c0 .028 0 .055.003.08A2.25 2.25 0 0 0 5.25 19H16.25a.75.75 0 0 0 0-1.5H5.249a.75.75 0 0 1 0-1.499H15a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2H6.249ZM5.248 14.5c-.263 0-.515.045-.75.128V4.251c0-.967.784-1.75 1.75-1.75h8.752a.5.5 0 0 1 .5.5V14a.5.5 0 0 1-.5.5H5.249Z" })));
});
